import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { waLink, WA_MESSAGES } from "../lib/whatsapp";

const projects = [
  {
    id: 1,
    label: "Growth & Performance",
    title: "Dashboards e campanhas orientadas a dados",
    img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000",
  },
  {
    id: 2,
    label: "Apps Mobile",
    title: "Aplicativos nativos e PWA de ponta a ponta",
    img: "https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000",
  },
  {
    id: 3,
    label: "Interfaces & Experiências",
    title: "Produtos digitais com foco em conversão",
    img: "https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg?auto=compress&cs=tinysrgb&w=940",
  },
  {
    id: 4,
    label: "Identidades Digitais",
    title: "Marcas com presença neon em cada detalhe",
    img: "https://images.unsplash.com/photo-1689443111130-6e9c7dfd8f9e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000",
  },
];

const demos = [
  {
    id: "site-institucional",
    title: "Site Institucional Profissional",
    desc: "Presença digital completa para sua empresa.",
    img: "https://images.unsplash.com/photo-1634084462412-b54873c0a56d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000",
    msg: WA_MESSAGES.demo_institucional,
  },
  {
    id: "catalogo-digital",
    title: "Catálogo Digital",
    desc: "Seus produtos e serviços organizados para vender.",
    img: "https://images.unsplash.com/photo-1720962158883-b0f2021fb51e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000",
    msg: WA_MESSAGES.demo_catalogo,
  },
  {
    id: "landing-page",
    title: "Landing Page de Alta Conversão",
    desc: "Uma página focada em transformar visita em contato.",
    img: "https://images.unsplash.com/photo-1648134859211-4a1b57575f4e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000",
    msg: WA_MESSAGES.demo_landing,
  },
];

const Projects = () => (
  <section id="projetos" className="relative py-20 sm:py-28">
    <div className="mx-auto max-w-6xl px-5">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-12"
      >
        <p className="mb-3 flex items-center gap-3 font-display text-[11px] font-bold uppercase tracking-[0.35em] text-brand-neon">
          <span className="h-px w-8 bg-brand-neon/60" />
          Projetos &amp; Portfólio
        </p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
          Ideias + Tecnologia
          <br />
          = <span className="text-brand-neon">Resultados.</span>
        </h2>
      </motion.div>

      <div className="grid gap-4 sm:grid-cols-2">
        {projects.map((p, i) => (
          <motion.figure
            key={p.id}
            data-testid={`portfolio-card-item-${p.id}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative overflow-hidden rounded-3xl border border-paper/8 bg-surface ${
              i % 3 === 0 ? "sm:row-span-2" : ""
            }`}
          >
            <img
              src={p.img}
              alt={p.title}
              loading="lazy"
              className="h-64 w-full object-cover opacity-80 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100 sm:h-80 sm:group-[&:nth-child(1)]:h-full"
            />
            <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(9,9,11,0.95),rgba(9,9,11,0.15)_55%,transparent)]" />
            <figcaption className="absolute inset-x-0 bottom-0 p-6">
              <span className="mb-2 inline-block rounded-full border border-brand-neon/40 bg-ink/60 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.25em] text-brand-neon backdrop-blur-sm">
                {p.label}
              </span>
              <h3 className="font-display text-lg font-bold leading-snug text-paper">
                {p.title}
              </h3>
            </figcaption>
          </motion.figure>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mt-12"
      >
        <div className="mb-6 flex items-end justify-between gap-4">
          <div>
            <p className="mb-2 flex items-center gap-3 font-display text-[11px] font-bold uppercase tracking-[0.35em] text-brand-neon">
              <span className="h-px w-8 bg-brand-neon/60" />
              Demonstrações
            </p>
            <h3 className="font-display text-xl font-bold tracking-tight sm:text-2xl">
              Exemplos do que podemos criar para você
            </h3>
          </div>
          <p className="hidden shrink-0 text-[10px] uppercase tracking-[0.25em] text-mist/60 sm:block">
            Exemplos ilustrativos
          </p>
        </div>

        <div
          data-testid="demo-carousel"
          className="-mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-2 sm:mx-0 sm:grid sm:grid-cols-3 sm:overflow-visible sm:px-0 sm:pb-0"
        >
          {demos.map((d, i) => (
            <motion.a
              key={d.id}
              href={waLink(d.msg)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`demo-card-${d.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group relative w-[78vw] max-w-[320px] shrink-0 snap-start overflow-hidden rounded-3xl border border-paper/8 bg-surface transition-colors duration-300 hover:border-brand-neon/40 sm:w-auto sm:max-w-none"
            >
              <img
                src={d.img}
                alt={d.title}
                loading="lazy"
                className="h-52 w-full object-cover object-top opacity-80 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100"
              />
              <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(9,9,11,0.98),rgba(9,9,11,0.62)_50%,rgba(9,9,11,0.08)_82%)]" />
              <span className="absolute left-4 top-4 rounded-full bg-brand/80 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-paper backdrop-blur-sm">
                Demonstração
              </span>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <h4 className="font-display text-base font-bold text-paper">
                  {d.title}
                </h4>
                <p className="mt-1 text-xs leading-relaxed text-mist">
                  {d.desc}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-neon">
                  Quero algo assim
                  <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </motion.div>

      <motion.a
        href={waLink(WA_MESSAGES.portfolio)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="portfolio-whatsapp-cta"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="group mt-8 flex items-center justify-between gap-4 rounded-3xl border border-brand-neon/30 bg-brand/10 p-6 transition-colors duration-300 hover:border-brand-neon/70 sm:p-7"
      >
        <div>
          <h3 className="font-display text-lg font-bold sm:text-xl">
            Quer ver o portfólio completo?
          </h3>
          <p className="mt-1 text-sm text-mist">
            Peça no WhatsApp e receba nossos cases na hora.
          </p>
        </div>
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-neon text-ink transition-transform duration-300 group-hover:scale-110 group-hover:rotate-45">
          <ArrowUpRight className="h-5 w-5" strokeWidth={2.4} />
        </span>
      </motion.a>
    </div>
  </section>
);

export default Projects;
